import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PersonResponse } from 'src/app/interfaces/person-response';
import Swiper from 'swiper';
import { Cast } from '../../interfaces/casting-response';


@Component({
  selector: 'app-cast-slideshow',
  templateUrl: './cast-slideshow.component.html',
  styleUrls: ['./cast-slideshow.component.css']
})
export class CastSlideshowComponent implements OnInit, AfterViewInit {

  @Input() cast: Cast[] = [];
  @Input() actor!: PersonResponse;

  constructor( private router: Router) { }

  ngOnInit(): void {
    // console.log(this.cast);
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    const swiper = new Swiper('.swiper-container-cast', {
      // Optional parameters
      direction: 'horizontal',
      freeMode: true,
      // loop: true,
      // effect: 'coverflow',
      grabCursor: true,
      centeredSlides: false,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 15
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 4,
          spaceBetween: 15
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 8.5,
          spaceBetween: 15
        }
      },
      // coverflowEffect: {
      //   rotate: 70,
      //   stretch: 100,
      //   depth: 10,
      //   modifier: 1,
      //   slideShadows: true,
      // },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      speed: 500,
      autoplay:{
        delay: 200
      },
    });

  }

  onPersonClick( actor: Cast ): void{
    this.router.navigate(['/actor', actor.id]);
  }

}
